import React, { FC, useContext, useEffect, useRef, useState } from 'react'
import { ProductDetailContext } from '../../../contexts/productDetailProvider'
import MaxWidth from '../../layout/MaxWidth/MaxWidth'
import Insta from './Insta/Insta'
import ProductDescription from './ProductDescription/ProductDescription'
import ProductDescriptionMobile from './ProductDescriptionMobile/ProductDescriptionMobile'
import ProductQuote from './ProductQuote/ProductQuote'
import ProductReviews from './ProductReviews/ProductReviews'
import Recomended from './Recomended/Recomended'
import Stories from './Stories/Stories'
import StoriesModal from './Stories/StoriesModal'
import Video from './Video/Video'
import { createPodeli } from '../../../lib/createPodeli'
import useWindowSize from '../../../hooks/useWindowSize'
import SchemaProduct from '../../schema/SchemaProduct'
import { getDateString } from '../../../lib/utils'

const ProductPage: FC<{ code: string }> = ({ code }) => {
  const [storyOpen, setStoryOpen] = useState<string>()

  const {
    product,
    test,
    pickedSku,
    setPickedSku,
    pickedSkuAroma,
    setPickedSkuAroma,
    hasSubsets,
    subsetsIds,
    discountActive,
    pickColor,
    pickedColors,
    reviews,
    loadingReviews,
    slides,
    stories,
    video,
    breadcrumbs,
    discountActiveTo,
    refetch,
    instagram,
  } = useContext(ProductDetailContext)
  const cartWidget = useRef()
  const [isScriptLoaded, setIsScriptLoaded] = useState(false)
  const { isMobile } = useWindowSize()

  useEffect(() => {
    //init scripts
    if (!document) return

    createPodeli(cartWidget, () => setIsScriptLoaded(true))
  }, [])

  useEffect(() => {
    //init cart widget

    if (
      !cartWidget.current ||
      !isScriptLoaded ||
      !document ||
      !document.querySelector(
        isMobile ? '.podeli_widget--mobile' : '.podeli_widget',
      )
    ) {
      return
    }

    try {
      // eslint-disable-next-line @typescript-eslint/no-extra-semi
      ;(cartWidget.current as any).init({
        total: pickedSku ? pickedSku.price : product.price,
        selectorToInject: isMobile
          ? '.podeli_widget--mobile'
          : '.podeli_widget',
      })
    } catch (e) {
      console.error('Cannot create podeli widget', e)
    }
  }, [cartWidget.current, pickedSku, product?.id, isScriptLoaded, isMobile])

  useEffect(() => {
    return () => {
      //remove all scripts
      document.querySelectorAll('#cart-podeli-scr')?.forEach((script) => {
        document.body.removeChild(script)
      })
    }
  }, [])

  return (
    <>
      <SchemaProduct
        description={product?.description.replace(/<[^>]+>/g, '').trim()}
        name={product?.title}
        previewImg={product?.img}
        price={product?.price.toString()}
        ratingValue={product?.rate?.toString()}
        reviewAuthor={reviews?.[0]?.name}
        reviewPublished={
          reviews?.[0]?.date ? getDateString(new Date(reviews[0]?.date)) : ''
        }
        reviewBody={reviews?.[0]?.text}
        reviewRating={reviews?.[0]?.rate?.toString()}
      />
      <ProductDescription
        key={code}
        product={product}
        test={test}
        pickedSku={pickedSku}
        setPickedSku={setPickedSku}
        pickedSkuAroma={pickedSkuAroma}
        setPickedSkuAroma={setPickedSkuAroma}
        hasSubsets={hasSubsets}
        subsetsIds={subsetsIds}
        discountActive={discountActive}
        pickColor={pickColor}
        pickedColors={pickedColors}
        slides={slides}
        breadcrumbs={breadcrumbs}
        discountActiveTo={discountActiveTo}
        refetch={refetch}
      />
      <MaxWidth mobileWide>
        <ProductDescriptionMobile
          key={code}
          product={product}
          test={test}
          pickedSku={pickedSku}
          setPickedSku={setPickedSku}
          pickedSkuAroma={pickedSkuAroma}
          setPickedSkuAroma={setPickedSkuAroma}
          hasSubsets={hasSubsets}
          subsetsIds={subsetsIds}
          discountActive={discountActive}
          pickColor={pickColor}
          pickedColors={pickedColors}
          slides={slides}
          discountActiveTo={discountActiveTo}
          refetch={refetch}
          breadcrumbs={breadcrumbs}
        />
      </MaxWidth>
      <Stories setStoryOpen={setStoryOpen} stories={stories} />
      <StoriesModal
        storyOpen={storyOpen}
        setStoryOpen={setStoryOpen}
        stories={stories}
      />
      <MaxWidth mobileWide>
        <Video video={video} />
      </MaxWidth>
      <MaxWidth>
        <ProductQuote quote={product?.quote} />
      </MaxWidth>
      <ProductReviews
        reviews={reviews}
        product={product}
        loadingReviews={loadingReviews}
      />
      <MaxWidth>
        <Recomended product={product} />
      </MaxWidth>
      <MaxWidth>
        <Insta instagram={instagram} />
      </MaxWidth>
    </>
  )
}

export default ProductPage
